import { getRenderer } from "@/components/component.store";
import { Attachments } from "./Attachments";
import { css } from "@linaria/core";

import { get } from "@/utils/object";
import {
  AccordionItem,
  type IAccordionItemProps,
} from "@/components/Accordion/Accordion";
import { CLASS_CONSTANTS } from "@/utils/constants";
import clsx from "clsx";
import { Fragment } from "react/jsx-runtime";
import type { PropsWithChildren } from "react";
import { RenderHtml } from "@/components/RenderHtml";

const { MESSAGE } = CLASS_CONSTANTS;
const OutgoingMessage = getRenderer("OutgoingMessage", AccordionItem);
const MessageBody = getRenderer("MessageBody", RenderHtml);

const messageItemClassName = css`
  .${MESSAGE.HEADER} {
    padding: 1em;
    background: var(--ws-message-header-bg);
    color: var(--ws-message-header-text, currentColor);
    margin-bottom: 0;
  }

  .${MESSAGE.BODY} {
    padding: 1em;
    background: var(--ws-message-body-bg);
    color: var(--ws-message-body-text, currentColor);
  }

  .${MESSAGE.ATTACHMENTS} {
    margin-inline: -1em;
    margin-block: 1em -1em;
    background: var(--ws-message-body-bg);
    color: var(--ws-message-body-text, currentColor);
  }
`;

export const Message = ({
  item = {},
  index,
  title,
  ...props
}: PropsWithChildren<
  IAccordionItemProps & { index: number; item?: object }
>) => {
  const MessageComponent = Fragment;
  const children = props.children ? <MessageBody>{props.children}</MessageBody> : (
    <>
      <MessageBody>{get(item, "body", "")}</MessageBody>
      <Attachments
        attachments={
          (item as Record<string, Record<string, string>>)?.attachment_urls
        }
      />
    </>
  );

  const itemProps = {
    children,
    title,
    header_classname: MESSAGE.HEADER,
    title_classname: MESSAGE.TITLE,
    body_classname: MESSAGE.BODY,
    defaultCollapsed: props.defaultCollapsed,
  };

  return (
    <MessageComponent>
      <OutgoingMessage
        className={clsx(MESSAGE.ROOT, props.className, messageItemClassName)}
        itemIndex={index}
        {...itemProps}
      />
    </MessageComponent>
  );
};
